<template>
  <div class="patient-record">
    <div v-if="!medicalRecordStarted" class="pr-init">
      <div class="pr-init__header">
        <span class="pr-init__title">Prontuário</span>
        <button class="pr-new-note-btn" @click="startMedicalRecord">
          + Nova nota
        </button>
      </div>

      <div class="pr-init__history">
        <p class="pr-init__history-label">Notas anteriores</p>
        <PatientRecordNotesHistory :appointment-id="room.appointment_id" />
      </div>
    </div>

    <div v-else>
      <form
        v-if="medicalRecordStatus === 'defaultMedicalRecord'"
        class="patient-record__form"
      >
        <div class="patient-record__form-header">
          <h2 class="patient-record__form-header-title">Prontuário online</h2>
        </div>

        <div class="patient-record__form-content">
          <div class="patient-record__form-content-group">
            <h4 class="patient-record__form-content-title mb-4">
              Dados pessoais
            </h4>
            <div class="custom-form-control">
              <label>Nome do paciente</label>
              <input
                class="form-control p-3 mb-4"
                type="text"
                value="Luana Maria dos Santos Oliveira"
              />
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <div class="custom-form-control mr-4" :style="fieldWidth">
                <label>Idade</label>
                <input class="form-control" type="number" />
              </div>

              <div class="custom-form-control mr-4" :style="fieldWidth">
                <label>Peso</label>
                <input class="form-control" type="number" />
              </div>

              <div class="custom-form-control mr-4" :style="fieldWidth">
                <label>Altura</label>
                <input class="form-control" type="tel" v-mask="['#.## m']" />
              </div>

              <div class="custom-select-form">
                <div class="custom-select-form-wrap">
                  <label>Tipo Sang.</label>
                  <select class="mr-4" :style="fieldWidth">
                    <option
                      v-for="(blody_type, index) in blood_types"
                      :key="index"
                    >
                      {{ blody_type }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="custom-form-control">
              <label>Observações</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <div class="patient-record__form-content-group">
            <h4 class="patient-record__form-content-title mb-4">
              Dados iniciais
            </h4>
            <div class="custom-form-control">
              <label>
                Queixa principal
                <small>(O que trouxe o paciente para a consulta)</small>
              </label>
              <input class="form-control p-3 mb-4" type="text" />
            </div>

            <div class="custom-form-control">
              <label>História da doença atual</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <div class="patient-record__form-content-group">
            <h4 class="patient-record__form-content-title mb-4">
              Antecedentes pessoais
            </h4>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="AllergiesCheck" />
                <label for="AllergiesCheck">Alergias</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="DiabetesCheck" />
                <label for="DiabetesCheck">Diabetes</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="hypertensionCheck" />
                <label for="hypertensionCheck">Hipertensão</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="illnessesCheck" />
                <label for="illnessesCheck">
                  Outras doenças pré-existentes
                </label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="medicationsCheck" />
                <label for="medicationsCheck">Medicações de uso contínuo</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="surgeriesCheck" />
                <label for="surgeriesCheck">Cirurgias</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-2">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="hospitalizationCheck" />
                <label for="hospitalizationCheck">Hospitalização</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="custom-form-control">
              <label>Outras observações:</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <div class="patient-record__form-content-group">
            <h4 class="patient-record__form-content-title mb-4">
              Antecedentes Sociais
            </h4>

            <div class="mb-4">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="smokingCheck" />
                <label for="smokingCheck">Tabagismo</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="mb-2">
              <div class="custom-check mb-3">
                <input type="checkbox" value="" id="alcoholicDrinksCheck" />
                <label for="alcoholicDrinksCheck">Bebidas Alcoólicas</label>
              </div>
              <div class="custom-form-control">
                <input class="form-control p-4" type="text" value="" />
              </div>
            </div>

            <div class="custom-form-control">
              <label>Outras observações:</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <div class="patient-record__form-content-group">
            <h4 class="patient-record__form-content-title mb-4">
              Exames Físicos
            </h4>

            <div class="custom-form-group mb-4">
              <label>Descreva os últimos exanes físicos realizados</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>

            <div class="custom-form-group">
              <label>Conduta:</label>
              <textarea
                class="form-control form-control-textarea"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <span class="d-flex align-items-flex justify-content-between">
            <Button variant="card" size="lg" @click.native="backToInit">
              Voltar
            </Button>
            <Button
              variant="primary"
              size="lg"
              @click.native="completeMedicalRecord"
            >
              Concluir
            </Button>
          </span>
        </div>
      </form>

      <div v-else class="patient-record__notes">
        <div v-if="!showHistory">
          <header class="patient-record__notes-header">
            <span class="patient-record__notes-header-title">Anotações</span>
            <button class="btn-ghost-white" @click="showNotesHistory">
              Histórico
            </button>
          </header>

          <div class="patient-record__notes-editor">
            <div class="patient-record__notes-editor-container">
              <quill-editor
                class="editor"
                ref="myTextEditor"
                :value="content"
                :options="editorOption"
                @change="onEditorChange"
              />
            </div>

            <div class="notes-actions">
              <button class="btn-ghost-white" @click="backToInit">
                Voltar
              </button>
              <button
                class="pr-new-note-btn"
                :disabled="!content.length"
                @click="saveAppointmentNotes"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>

        <div class="notes-history-wrap" v-else>
          <button class="btn-ghost-white mb-3" @click="hideNotesHistory">
            ← Anotações
          </button>
          <PatientRecordNotesHistory :appointment-id="room.appointment_id" />
        </div>
      </div>

      <b-toast
        id="appointmentNotesToast"
        title="Sucesso!"
        variant="success"
        :auto-hide-delay="2000"
      >
        Anotações salvas com sucesso!
      </b-toast>
    </div>
  </div>
</template>

<script>
import Button from "./Button";
import { quillEditor } from "vue-quill-editor";
import dedent from "dedent";
import debounce from "lodash/debounce";
import hljs from "highlight.js/lib/core";

import PatientRecordNotesHistory from "./PatientRecordNotesHistory.vue";

export default {
  name: "PatientRecordForm",
  components: {
    Button,
    quillEditor,
    PatientRecordNotesHistory
  },
  props: {
    room: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      medicalRecordStarted: false,
      showHistory: false,
      medicalRecordStatus: "blankDocument",
      blood_types: ["A +", "B +", "AB +", "A -", "B -", "AB -", "O +", "O -"],
      appointmentNotes: [],
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
              { header: 1 },
              { header: 2 },
              { list: "ordered" },
              { list: "bullet" },
              { script: "sub" },
              { script: "super" },
              { align: [] },
              "clean",
              "link",
              "image"
            ]
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      content: dedent``
    };
  },

  mounted() {
    this.fetchAppointmentNotes();
  },

  methods: {
    sendAppointmentNotes() {
      this.$store.dispatch("appointments/appointmentNotes", {
        description: this.content,
        appointmentId: this.room.appointment_id
      });
    },
    fetchAppointmentNotes() {
      this.$store
        .dispatch(
          "appointments/fetchAppointmentNotes",
          this.room.appointment_id
        )
        .then(response => {
          this.appointmentNotes = response.data;
        });
    },
    startMedicalRecord() {
      if (this.medicalRecordStatus === "blankDocument") {
        this.content = "";
      }
      this.medicalRecordStarted = true;
    },
    cancelMedicalRecord() {
      this.$emit("cancelMedicalRecord");
    },
    completeMedicalRecord() {
      this.medicalRecordStatus = "completeMedicalRecord";
    },
    onEditorChange: debounce(function(value) {
      this.content = value.html;
    }, 500),
    backToInit() {
      this.medicalRecordStarted = false;
    },
    saveAppointmentNotes() {
      this.sendAppointmentNotes();
      this.$bvToast.show("appointmentNotesToast");
      setTimeout(() => {
        this.medicalRecordStarted = false;
        this.medicalRecordStatus = "blankDocument";
      }, 1800);
    },
    showNotesHistory() {
      this.showHistory = true;
    },
    hideNotesHistory() {
      this.showHistory = false;
    }
  },

  computed: {
    fieldWidth() {
      return {
        width: "100%",
        maxWidth: "120px"
      };
    },
    contentCode() {
      return hljs.highlightAuto(this.content).value;
    },
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },

  watch: {
    medicalRecordStarted(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.myTextEditor && this.$refs.myTextEditor.quill) {
            this.$refs.myTextEditor.quill.focus();
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.btn-ghost-white {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  cursor: pointer;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  transition: color 0.15s;

  &:hover {
    color: #fff;
  }
}

.notes-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--space-4);
}

.notes-history-wrap {
  padding: var(--space-4) var(--space-5);
  display: flex;
  flex-direction: column;
}

.pr-new-note-btn {
  background: rgba(26, 108, 247, 0.15);
  border: 1px solid rgba(26, 108, 247, 0.4);
  border-radius: var(--radius-md);
  color: #7eb3fc;
  font-size: var(--font-size-xs);
  font-weight: var(--fw-semibold);
  padding: var(--space-1) var(--space-3);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: rgba(26, 108, 247, 0.25);
    color: #fff;
  }
}

.pr-init {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-5);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: var(--font-size-md);
    font-weight: var(--fw-bold);
    color: #fff;
  }

  &__history-label {
    font-size: var(--font-size-xs);
    font-weight: var(--fw-semibold);
    color: rgba(255, 255, 255, 0.4);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: var(--space-3);
  }
}
</style>
